import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: string;
  title: string;
  slug: string;
  summary: string;
  category: string;
  categoryName: string;
  coverImage: string;
  author: string;
  publishedAt: string;
  readTime: string;
}

export default function ArticleCard({
  title,
  slug,
  summary,
  category,
  categoryName,
  coverImage,
  author,
  publishedAt,
  readTime,
}: ArticleCardProps) {
  return (
    <article className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 group cursor-pointer">
      <Link to={`/article/${slug}`} className="block">
        <div className="relative overflow-hidden">
          <img
            src={coverImage}
            alt={title}
            className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute top-3 left-3">
            <Link
              to={`/category/${category}`}
              className="px-3 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              {categoryName}
            </Link>
          </div>
        </div>
        <div className="p-5">
          <h3 className="text-lg font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {title}
          </h3>
          <p className="text-foreground-600 text-sm leading-relaxed mb-4 line-clamp-2">
            {summary}
          </p>
          <div className="flex items-center justify-between text-xs text-foreground-500">
            <div className="flex items-center gap-3">
              <span className="flex items-center gap-1">
                <i className="ri-user-line"></i>
                {author}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-time-line"></i>
                {readTime}
              </span>
            </div>
            <span>{publishedAt}</span>
          </div>
        </div>
      </Link>
    </article>
  );
}